define(function (require) {

    var BASE = require('web-agent-adapters/BaseAdapter');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var logger = WebAgentLogger.getLogger(this.applicationType);

    var lpMessagingAgentListForTransferAdapter = BASE.extend(function (options) {});

    // in order to determine the agents order in the list, we unify their status with the name
    var AGENT_STATUS_ORDER = {
        ONLINE: 1,
        BACK_SOON: 2,
        AWAY: 3,
        OFFLINE: 4
    };

    function successHandlerCreator(res) {
        if (res && res.body && res.body._metadata) {
            logger.debug("Messaging agent list for transfer return as Success", "successHandlerCreator");
            return {
                count: res.body._metadata.count,
                data: mapRecordsData(res.body)
            };
        } else {
            return null;
        }
    }

    function errorHandlerCreator(res) {
        var errorMessage = res && res.error ? res.error.message : "Error in messaging agent list for transfer.";
        logger.error(errorMessage, "Messaging agent list for transfer");
        logger.graph({ name: 'messagingAgentListForTransferError' });
        return errorMessage;
    }

    function getStatusNameSorting(agentPresence, currentStatus, agentName) {
        return (agentPresence === "true" ? AGENT_STATUS_ORDER[currentStatus] : AGENT_STATUS_ORDER.OFFLINE) + agentName;
    }

    function mapRecordsData(res) {
        var data = [];
        (res.agentStatusRecords || []).forEach(function (record) {
            data.push({
                agentId: record.agentId,
                agentName: record.agentName,
                agentPresence: record.agentPresence === "true",
                currentStatus: record.currentStatus,
                currentStatusReason: record.currentStatusReason,
                load: record.load,
                agentSkills: record.agentSkills,
                statusNameSort: getStatusNameSorting(record.agentPresence, record.currentStatus, record.agentName)
            });
        });
        return data;
    }

    lpMessagingAgentListForTransferAdapter.prototype.applicationType = 'lpMessagingAgentListForTransferAdapter';

    lpMessagingAgentListForTransferAdapter.prototype.searchMessagingAgentsList = function (request) {

        var successHandler = request.success;
        var errorHandler = request.error;

        request.success = function (res) {
            var successHandlerData = successHandlerCreator(res);
            if (successHandlerData) {
                successHandler(successHandlerData);
            } else {
                handleError(res);
            }
        };

        request.error = handleError;

        function handleError(res) {
            var errorHandlerData = errorHandlerCreator(res);
            errorHandler(errorHandlerData);
        }

        return this.service.searchMessagingAgentsList(request);
    };


    return lpMessagingAgentListForTransferAdapter;

});
